import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// api
import { getSmallReviews } from 'api/libros';
// components
import ItemList from 'components/itemList/item';
import Head from 'components/metatags_helmet/metatags';
// images
import Paperplane from 'assets/img/background_paperplane.png';
//styles
import './smallReviews.scss';

const SmallReviews = () => {
  const [items, setItems] = useState([]);
  const [itemsShow, setItemsShow] = useState([]);
  const { t } = useTranslation(['mix', 'backoffice']);

  const getLoadData = async () => {
    const { status, data } = await getSmallReviews();
    if (status === 200) {
      setItems(data);
    }
  };

  useEffect(() => {
    getLoadData();
  }, []);

  useEffect(() => {
    const addField = () => {
      const itemsTemp = items.map((el) => {
        el.libro[0].editorial = 'Editorial Española';
        return el;
      });
      setItemsShow(itemsTemp);
    };
    addField();
  }, [items]);

  return (
    <div className="container-fluid px-0 mainDiv">
      <Head description={'descriptionSeo'} title={'metaTitleSeo'} />
      <Row className="px-2 mx-0">
        <Col md={12} className="pl-1">
          <h1 className="page-title static-title mt-4 openSansItalic">
            {t('infantil', { ns: 'backoffice' })} - {t('pequenasResenas')}
          </h1>
        </Col>
      </Row>
      <Container fluid className="px-0 mx-0">
        <Row className="justify-content-center pl-3 mx-0">
          <Col lg={12}>
            <Row className="itemsRow">
              {itemsShow.map((item, i) => (
                <Col md={4} lg={3} sm={6} key={i} className="mt-2">
                  <ItemList
                    key={i}
                    data={item.libro[0]}
                    isReview={true}
                    reviewId={item.id}
                  />
                </Col>
              ))}
            </Row>
            <Row className="">
              <Col className="d-flex justify-content-center">
                <img src={Paperplane} alt="paper.png" className="planeImg" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SmallReviews;
